<div style="max-width: 480px; margin: 0 auto; background: #f8f9fa; min-height: 100vh; position: relative;">

  <!-- Header -->
  <header style="display: flex; flex-direction: column; padding: 16px 20px; background: white; box-shadow: 0 2px 4px rgba(0,0,0,0.05); gap: 12px;">
    <div style="display: flex; justify-content: center; align-items: center; padding-bottom: 8px;">
      <img src="assets/img/Logo.svg" alt="Aguacate Wallet" style="height: 40px; width: auto;" />
    </div>
    <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px;">
      <button *ngIf="currentStep > 1" type="button" (click)="previousStep()"
        style="display: flex; align-items: center; gap: 4px; background: none; border: none; font-size: 14px; font-weight: 600; color: #333; cursor: pointer; padding: 8px; border-radius: 4px;"
        onmouseover="this.style.background='#f0f0f0'" onmouseout="this.style.background='none'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        ATRÁS
      </button>
      <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem; flex: 1;">
        <div style="background-color: #1C593D; color: white; padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.875rem; font-weight: 600; white-space: nowrap;">
          Paso {{ currentStep }}/{{ totalSteps }}
        </div>
        <div style="width: 100%; height: 12px; background-color: #b2f0c0; border-radius: 999px; overflow: hidden;">
          <div style="height: 100%; background-color: #1C593D; border-radius: 999px; transition: width 0.3s ease;"
            [style.width.%]="(currentStep / totalSteps) * 100"></div>
        </div>
      </div>
    </div>
  </header>

  <!-- ═══ STEP 1: Cotiza tu envío ═══ -->
  <div style="padding: 20px;" *ngIf="currentStep === 1">
    <div style="margin-bottom: 20px;">
      <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Cotiza tu envío</h2>
      <p style="font-size: 14px; color: #666; margin: 0;">Realiza el envío</p>
    </div>

    <!-- Horario de operacion -->
    <div style="display: flex; align-items: center; gap: 8px; background: #e8f5e9; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">⏱️</span>
      <span style="font-size: 14px; color: #1e5a3f; font-weight: 500;">Horario de operacion: <strong>4:00 - 23:00</strong></span>
    </div>

    <!-- Balance Display -->
    <div style="background: #e8f5e9; border-radius: 12px; padding: 16px; margin-bottom: 24px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 14px; color: #2d5f3f; font-weight: 500;">Saldo actual</span>
        <span style="font-size: 18px; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 6px;">
          {{ formatCurrency(currentBalance, selectedSendCurrency) }}
          {{ selectedSendCurrency.code }}
          <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
            [src]="getFlagPath(selectedSendCurrency)" [alt]="selectedSendCurrency.code" />
        </span>
      </div>
      <button *ngIf="currentBalance === 0" type="button" (click)="recargarSaldo()"
        style="width: 100%; margin-top: 12px; padding: 12px 16px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.3s ease;"
        onmouseover="this.style.background='#258068'" onmouseout="this.style.background='#1C593D'">
        Recargar saldo
      </button>
    </div>

    <!-- Monto mínimo info -->
    <div *ngIf="currentBalance > 0"
      style="display: flex; align-items: center; gap: 8px; background: #e8f5e9; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">💵</span>
      <span *ngIf="!isVeUser" style="font-size: 14px; color: #1e5a3f;">Monto mínimo de envío <strong>$10.000</strong> CLP</span>
      <span *ngIf="isVeUser" style="font-size: 14px; color: #1e5a3f;">Monto mínimo de envío <strong>{{ formatAmountWithThousands(minSendAmount) }}</strong> VES (equiv. $10.000 CLP)</span>
    </div>

    <!-- Error saldo insuficiente -->
    <div *ngIf="currentBalance === 0" class="error-shake"
      style="display: flex; align-items: center; gap: 8px; background: #ffebee; border: 2px solid #ef5350; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">⚠️</span>
      <span style="font-size: 14px; color: #c62828; font-weight: 500;">
        Saldo insuficiente. <strong style="color: #b71c1c;">Recarga tu cuenta</strong> para realizar envíos
      </span>
    </div>

    <!-- Error monto máximo -->
    <div *ngIf="isSendAmountExceedingMax()" class="error-shake"
      style="display: flex; align-items: center; gap: 8px; background: #ffebee; border: 2px solid #ef5350; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">⚠️</span>
      <span *ngIf="!isVeUser" style="font-size: 14px; color: #c62828; font-weight: 500;">
        Monto máximo de envío es <strong style="color: #b71c1c;">${{ formatAmountWithThousands(maxSendAmount) }}</strong> CLP
      </span>
      <span *ngIf="isVeUser" style="font-size: 14px; color: #c62828; font-weight: 500;">
        Monto máximo de envío es <strong style="color: #b71c1c;">{{ formatAmountWithThousands(maxSendAmount) }}</strong> VES
      </span>
    </div>

    <form [formGroup]="transferForm">
      <!-- Send Amount -->
      <div style="margin-bottom: 20px; position: relative;">
        <label style="display: block; font-size: 14px; font-weight: 600; color: #1C593D; margin-bottom: 8px;">Tú envías</label>
        <div #sendWrapper style="display: flex; align-items: center; background: white; border: 2px solid #e0e0e0; border-radius: 12px; padding: 12px 16px; transition: border-color 0.2s;">
          <!-- `type=text` + `appMonto`: el monto se ve con separador de miles
               mientras se tipea (120,000 en vez de 120000). Con `type=number`
               el navegador vacía el campo apenas aparece una coma. La directiva
               filtra a sólo dígitos, así que el `keydown` manual sobra. -->
          <input type="text" class="no-spinner" inputmode="numeric" appMonto [decimales]="0"
            formControlName="sendAmount"
            (input)="onSendAmountChange()"
            (focus)="sendWrapper.style.borderColor='#1C593D'" (blur)="sendWrapper.style.borderColor='#e0e0e0'"
            placeholder="0"
            style="flex: 1; border: none; outline: none; font-size: 26px; font-weight: 700; color: #1a1a1a; background: transparent; width: 100%;" />
          <button type="button"
            style="display: flex; align-items: center; gap: 6px; background: #f5f5f5; border: none; padding: 8px 12px; border-radius: 8px; font-size: 14px; font-weight: 600; color: #1e5a3f; cursor: default; flex-shrink: 0; white-space: nowrap;">
            <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
              [src]="getFlagPath(selectedSendCurrency)" [alt]="selectedSendCurrency.code" />
            {{ selectedSendCurrency.code }}
          </button>
        </div>
        <button type="button"
          style="position: absolute; left: 50%; bottom: -48px; transform: translateX(-50%); width: 48px; height: 48px; border-radius: 50%; background: #1C593D; border: 4px solid #f8f9fa; display: flex; align-items: center; justify-content: center; cursor: default; z-index: 10;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 10L12 5L17 10M17 14L12 19L7 14" stroke="white" stroke-width="2" />
          </svg>
        </button>
      </div>

      <!-- Receive Amount -->
      <div style="margin-bottom: 20px;">
        <label style="display: block; font-size: 14px; font-weight: 600; color: #1C593D; margin-bottom: 8px;">Beneficiario recibe</label>
        <div #receiveWrapper style="display: flex; align-items: center; background: white; border: 2px solid #e0e0e0; border-radius: 12px; padding: 12px 16px; transition: border-color 0.2s;">
          <!-- Decimales por moneda recibida: el cliente CL recibe VES (2) y el
               VE recibe CLP (0). El separador decimal pasa a ser el punto, como
               en el resto de la app ("9,619.67"); por eso se va el `keydown`,
               que lo bloqueaba. -->
          <input type="text" formControlName="receiveAmount"
            inputmode="numeric" appMonto [decimales]="isVeUser ? 0 : 2"
            (input)="onReceiveAmountChange()"
            (focus)="receiveWrapper.style.borderColor='#1C593D'" (blur)="receiveWrapper.style.borderColor='#e0e0e0'"
            placeholder="0"
            style="flex: 1; border: none; outline: none; font-size: 26px; font-weight: 700; color: #1a1a1a; background: transparent; width: 100%;" />
          <button type="button"
            style="display: flex; align-items: center; gap: 6px; background: #f5f5f5; border: none; padding: 8px 12px; border-radius: 8px; font-size: 14px; font-weight: 600; color: #1e5a3f; cursor: default; flex-shrink: 0; white-space: nowrap;">
            <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
              [src]="getFlagPath(selectedReceiveCurrency)" [alt]="selectedReceiveCurrency.code" />
            {{ selectedReceiveCurrency.code }}
          </button>
        </div>
      </div>
    </form>

    <!-- Transfer Details -->
    <div style="background: white; border-radius: 12px; padding: 16px; margin-bottom: 16px;">
      <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 18px;">💰</span>
        <span style="flex: 1; font-size: 14px; color: #1e5a3f;">Costo de envío:</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">0.00 {{ isVeUser ? 'VES' : 'VES' }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 18px;">💱</span>
        <span style="flex: 1; font-size: 14px; color: #1e5a3f;">Monto a convertir:</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ amountToConvert.toFixed(2) }} {{ isVeUser ? 'VES' : 'CLP' }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 8px 0;">
        <span style="font-size: 18px;">📊</span>
        <span style="flex: 1; font-size: 14px; color: #1e5a3f;">Tipo de cambio:</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ exchangeType }}</span>
      </div>
    </div>

    <!-- Arrival Time -->
    <div style="display: flex; align-items: center; gap: 8px; background: #e3f2fd; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">⏱️</span>
      <span style="font-size: 14px; color: #1565c0;">Tu dinero llegará en <strong>15 minutos</strong></span>
    </div>

    <!-- Aviso Pago Móvil no disponible (solo CL) -->
    <div *ngIf="!isVeUser && pagoMovilDisabled"
      style="display: flex; align-items: center; gap: 8px; background: #fff3e0; border: 1px solid #ffb74d; border-radius: 12px; padding: 12px 16px; margin-bottom: 20px;">
      <span style="font-size: 20px;">📱</span>
      <span style="font-size: 14px; color: #e65100; font-weight: 500;"><strong>Pago Móvil</strong> no está disponible por el momento. Por favor selecciona otro método de pago.</span>
    </div>

    <!-- Ver Tasas Button -->
    <button type="button" (click)="openRatesModal()"
      style="width: 100%; padding: 12px; background: transparent; border: 2px solid #1C593D; color: #1C593D; font-size: 14px; font-weight: 600; border-radius: 12px; cursor: pointer; margin-bottom: 12px; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.3s ease;"
      onmouseover="this.style.background='#1C593D'; this.style.color='white'" onmouseout="this.style.background='transparent'; this.style.color='#1C593D'">
      📊 Ver tasas del día
    </button>

    <!-- Continue Button -->
    <button type="button" [disabled]="!canProceed()" (click)="nextStep()"
      [style.background]="canProceed() ? '#1C593D' : '#d0d0d0'"
      [style.cursor]="canProceed() ? 'pointer' : 'not-allowed'"
      [style.opacity]="canProceed() ? '1' : '0.6'"
      style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s, transform 0.1s;">
      Continuar
    </button>
  </div>

  <!-- ═══ STEP 2: Beneficiario ═══ -->
  <div style="padding: 20px;" *ngIf="currentStep === 2">
    <div style="margin-bottom: 20px;">
      <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Beneficiario</h2>
      <p style="font-size: 14px; color: #666; margin: 0;">Selecciona o agrega tu beneficiario</p>
    </div>

    <!-- Search Bar -->
    <div style="position: relative; margin-bottom: 16px;">
      <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar contacto"
        style="width: 100%; padding: 14px 48px 14px 16px; border: 2px solid #e0e0e0; border-radius: 12px; font-size: 15px; outline: none; transition: border-color 0.2s; box-sizing: border-box;"
        onfocus="this.style.borderColor='#1C593D'" onblur="this.style.borderColor='#e0e0e0'" />
      <button type="button"
        style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #666; padding: 8px;">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="2" />
          <path d="M14 14L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Aviso Pago Móvil no disponible (solo CL) -->
    <div *ngIf="!isVeUser && pagoMovilDisabled"
      style="display: flex; align-items: center; gap: 8px; background: #fff3e0; border: 1px solid #ffb74d; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px;">
      <span style="font-size: 20px;">📱</span>
      <span style="font-size: 14px; color: #e65100; font-weight: 500;"><strong>Pago Móvil</strong> no está disponible por el momento. Por favor selecciona otro método de pago.</span>
    </div>

    <!-- Add Beneficiary Button (solo CL) -->
    <button *ngIf="!isVeUser" type="button" (click)="openAddBeneficiaryDialog()"
      style="width: 100%; padding: 14px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; margin-bottom: 24px; transition: all 0.2s;"
      onmouseover="this.style.background='#f0f9f5'" onmouseout="this.style.background='white'">
      Agregar beneficiario
    </button>

    <!-- === CL: Beneficiary List (Venezuelan accounts) === -->
    <ng-container *ngIf="!isVeUser">
      <div style="margin-bottom: 24px;">
        <h3 style="font-size: 16px; font-weight: 700; color: #1a1a1a; margin: 0 0 16px 0;">Tus beneficiarios</h3>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <label *ngFor="let beneficiary of filteredBeneficiaries"
            style="display: flex; align-items: center; gap: 12px; padding: 16px; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
            [style.background]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#f0f9f5' : 'white'"
            [style.border]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '2px solid #1C593D' : '2px solid #e0e0e0'">
            <input type="radio" name="beneficiary" [value]="beneficiary.cuentaBeneficiarioID"
              [checked]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID"
              (change)="selectBeneficiary(beneficiary)" style="display: none;" />
            <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0;">
              <div style="width: 48px; height: 48px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #4caf50); display: flex; align-items: center; justify-content: center; color: white; font-size: 20px; font-weight: 700; flex-shrink: 0;">
                {{ beneficiary.nombre.charAt(0) }}
              </div>
              <div style="display: flex; flex-direction: column; gap: 4px; min-width: 0;">
                <span style="font-size: 15px; font-weight: 600; color: #1a1a1a; overflow: hidden; text-overflow: ellipsis;">
                  {{ beneficiary.nombre }} {{ beneficiary.apellidos }}
                </span>
                <span style="font-size: 13px; color: #666; display: flex; align-items: center; gap: 4px;">
                  <span style="font-size: 14px;">🏦</span>
                  {{ beneficiary.banco?.nombre }} - {{ beneficiary.numeroCuenta }}
                </span>
              </div>
            </div>
            <div style="width: 24px; height: 24px; border-radius: 50%; position: relative; flex-shrink: 0; transition: all 0.2s;"
              [style.border]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '2px solid #1C593D' : '2px solid #d0d0d0'"
              [style.background]="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID ? '#1C593D' : 'transparent'">
              <div *ngIf="selectedBeneficiary?.cuentaBeneficiarioID === beneficiary.cuentaBeneficiarioID"
                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
            </div>
          </label>
        </div>
      </div>

      <button type="button" [disabled]="!selectedBeneficiary" (click)="nextStep()"
        [style.background]="selectedBeneficiary ? '#1C593D' : '#d0d0d0'"
        [style.cursor]="selectedBeneficiary ? 'pointer' : 'not-allowed'"
        [style.opacity]="selectedBeneficiary ? '1' : '0.6'"
        style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s, transform 0.1s;">
        Continuar
      </button>
    </ng-container>

    <!-- === VE: Beneficiary List (Chilean accounts) === -->
    <ng-container *ngIf="isVeUser">
      <!-- Add Chilean Account Button -->
      <button type="button" (click)="openAddVesBeneficiaryDialog()"
        style="width: 100%; padding: 14px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; margin-bottom: 24px; transition: all 0.2s;"
        onmouseover="this.style.background='#f0f9f5'" onmouseout="this.style.background='white'">
        Agregar cuenta chilena
      </button>

      <div style="margin-bottom: 24px;">
        <h3 style="font-size: 16px; font-weight: 700; color: #1a1a1a; margin: 0 0 16px 0;">Tus cuentas chilenas</h3>
        <div style="display: flex; flex-direction: column; gap: 12px;">
          <label *ngFor="let cuenta of filteredVesBeneficiaries"
            style="display: flex; align-items: center; gap: 12px; padding: 16px; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
            [style.background]="selectedVesBeneficiary?.id === cuenta.id ? '#f0f9f5' : 'white'"
            [style.border]="selectedVesBeneficiary?.id === cuenta.id ? '2px solid #1C593D' : '2px solid #e0e0e0'">
            <input type="radio" name="vesBeneficiary" [value]="cuenta.id"
              [checked]="selectedVesBeneficiary?.id === cuenta.id"
              (change)="selectVesBeneficiary(cuenta)" style="display: none;" />
            <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0;">
              <div style="width: 48px; height: 48px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #4caf50); display: flex; align-items: center; justify-content: center; color: white; font-size: 20px; font-weight: 700; flex-shrink: 0;">
                {{ (cuenta.alias || cuenta.banco || 'C').charAt(0) }}
              </div>
              <div style="display: flex; flex-direction: column; gap: 4px; min-width: 0;">
                <span style="font-size: 15px; font-weight: 600; color: #1a1a1a; overflow: hidden; text-overflow: ellipsis;">
                  {{ cuenta.alias || 'Cuenta ' + cuenta.numeroCuenta }}
                </span>
                <span style="font-size: 13px; color: #666; display: flex; align-items: center; gap: 4px;">
                  <span style="font-size: 14px;">🏦</span>
                  {{ cuenta.banco }} - {{ cuenta.numeroCuenta }}
                </span>
                <span style="font-size: 12px; color: #999;">{{ cuenta.tipoCuenta }}</span>
              </div>
            </div>
            <div style="width: 24px; height: 24px; border-radius: 50%; position: relative; flex-shrink: 0; transition: all 0.2s;"
              [style.border]="selectedVesBeneficiary?.id === cuenta.id ? '2px solid #1C593D' : '2px solid #d0d0d0'"
              [style.background]="selectedVesBeneficiary?.id === cuenta.id ? '#1C593D' : 'transparent'">
              <div *ngIf="selectedVesBeneficiary?.id === cuenta.id"
                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
            </div>
          </label>

          <!-- Empty state VE -->
          <div *ngIf="filteredVesBeneficiaries.length === 0"
            style="text-align: center; padding: 30px 16px; border: 2px dashed #e0e0e0; border-radius: 12px;">
            <span style="font-size: 40px; display: block; margin-bottom: 8px;">🏦</span>
            <p style="font-size: 15px; font-weight: 600; color: #1e5a3f; margin: 0 0 4px;">No tienes cuentas chilenas</p>
            <p style="font-size: 13px; color: #666; margin: 0;">Agrega una cuenta de retiro CLP para continuar</p>
          </div>
        </div>
      </div>

      <button type="button" [disabled]="!selectedVesBeneficiary" (click)="nextStep()"
        [style.background]="selectedVesBeneficiary ? '#1C593D' : '#d0d0d0'"
        [style.cursor]="selectedVesBeneficiary ? 'pointer' : 'not-allowed'"
        [style.opacity]="selectedVesBeneficiary ? '1' : '0.6'"
        style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s, transform 0.1s;">
        Continuar
      </button>
    </ng-container>
  </div>

  <!-- ═══ STEP 3: Resumen de operación ═══ -->
  <div style="padding: 20px;" *ngIf="currentStep === 3">
    <div style="margin-bottom: 20px;">
      <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Valida tu operación</h2>
      <p style="font-size: 14px; color: #666; margin: 0;">Revisa que todos los datos estén bien</p>
    </div>

    <div style="background: white; border-radius: 12px; padding: 20px; margin-bottom: 20px;">
      <h3 style="font-size: 18px; font-weight: 700; color: #1C593D; margin: 0 0 16px 0;">Resumen de operación</h3>

      <!-- Beneficiario info -->
      <div style="display: flex; flex-direction: column; gap: 4px; padding-bottom: 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px;">
        <span style="font-size: 13px; color: #666; font-weight: 500;">Beneficiario</span>
        <span *ngIf="!isVeUser" style="font-size: 15px; font-weight: 600; color: #1e5a3f;">
          {{ getSelectedBeneficiaryName() }} - {{ getSelectedBeneficiaryBank() }}
        </span>
        <span *ngIf="isVeUser" style="font-size: 15px; font-weight: 600; color: #1e5a3f;">
          {{ selectedVesBeneficiary?.alias || selectedVesBeneficiary?.numeroCuenta }} - {{ selectedVesBeneficiary?.banco }}
        </span>
      </div>

      <!-- Amount boxes -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px;">
        <div style="background: #f8f9fa; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Tú envías</span>
          <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px;">{{ sendAmount.toFixed(2) }}</div>
          <div style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 600; color: #333;">
            <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
              [src]="getFlagPath(selectedSendCurrency)" [alt]="selectedSendCurrency.code" />
            {{ selectedSendCurrency.code }}
          </div>
        </div>
        <div style="background: #f8f9fa; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Beneficiario recibe</span>
          <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px;">{{ receiveAmount.toFixed(2) }}</div>
          <div style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 600; color: #333;">
            <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
              [src]="getFlagPath(selectedReceiveCurrency)" [alt]="selectedReceiveCurrency.code" />
            {{ selectedReceiveCurrency.code }}
          </div>
        </div>
      </div>

      <!-- Transaction details -->
      <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0; border-bottom: 1px solid #f0f0f0;">
        <span style="font-size: 18px;">💰</span>
        <span style="flex: 1; font-size: 14px; color: #1e5a3f;">Costo de envío:</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;">{{ transferFee }}.00 {{ isVeUser ? 'VES' : 'VES' }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0;">
        <span style="font-size: 18px;">⏱️</span>
        <span style="flex: 1; font-size: 14px; color: #1e5a3f;">Tu dinero llegará en:</span>
        <span style="font-size: 14px; font-weight: 600; color: #1e5a3f;"><strong>15 minutos</strong></span>
      </div>
    </div>

    <!-- Confirm Button (disable after click for security) -->
    <button type="button" [disabled]="isSubmitting" (click)="nextStep()"
      [style.background]="isSubmitting ? '#9ca3af' : '#1C593D'"
      [style.cursor]="isSubmitting ? 'not-allowed' : 'pointer'"
      style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s, transform 0.1s;">
      {{ isSubmitting ? 'Procesando...' : 'Confirmar' }}
    </button>
  </div>

  <!-- ═══ STEP 4: Transacción completada ═══ -->
  <div style="padding: 20px;" *ngIf="currentStep === 4">
    <div style="display: flex; flex-direction: column; align-items: center;">
      <!-- Aguacate image -->
      <div style="width: 100%; display: flex; justify-content: center; margin-bottom: 20px;">
        <img src="assets/icons/aguacatepay.svg" alt="AguacatePay"
          style="width: 250px; height: 250px; margin: 20px auto; display: block;" />
      </div>

      <div style="text-align: center; margin-bottom: 24px;">
        <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 8px 0;">Transacción creada</h2>
        <p style="font-size: 14px; color: #666; margin: 0;">La operación fue realizada con éxito</p>
      </div>

      <!-- Transaction summary -->
      <div style="width: 100%; background: white; border-radius: 12px; padding: 20px; margin-bottom: 16px;">
        <div style="display: flex; flex-direction: column; gap: 4px; padding-bottom: 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px;">
          <span style="font-size: 13px; color: #666; font-weight: 500;">Beneficiario</span>
          <span *ngIf="!isVeUser" style="font-size: 15px; font-weight: 600; color: #1e5a3f;">
            {{ getSelectedBeneficiaryName() }} - {{ getSelectedBeneficiaryBank() }}
          </span>
          <span *ngIf="isVeUser" style="font-size: 15px; font-weight: 600; color: #1e5a3f;">
            {{ selectedVesBeneficiary?.alias || selectedVesBeneficiary?.numeroCuenta }} - {{ selectedVesBeneficiary?.banco }}
          </span>
        </div>

        <!-- Amount boxes -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px;">
          <div style="background: #f8f9fa; border: 2px solid #e0e0e0; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Tú envías</span>
            <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px;">{{ sendAmount.toFixed(2) }}</div>
            <div style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 600; color: #333;">
              <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
                [src]="getFlagPath(selectedSendCurrency)" [alt]="selectedSendCurrency.code" />
              {{ selectedSendCurrency.code }}
            </div>
          </div>
          <div style="background: #f8f9fa; border: 2px solid #e0e0e0; border-radius: 12px; padding: 16px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <span style="display: block; font-size: 12px; color: #666; margin-bottom: 8px; font-weight: 500;">Beneficiario recibe</span>
            <div style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px;">{{ receiveAmount.toFixed(2) }}</div>
            <div style="display: inline-flex; align-items: center; gap: 4px; background: white; padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 600; color: #333;">
              <img style="width: 20px; height: 20px; object-fit: cover; border-radius: 2px;"
                [src]="getFlagPath(selectedReceiveCurrency)" [alt]="selectedReceiveCurrency.code" />
              {{ selectedReceiveCurrency.code }}
            </div>
          </div>
        </div>

        <!-- Arrival info -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #e3f2fd; border-radius: 8px;">
          <span style="font-size: 18px;">⏱️</span>
          <span style="font-size: 14px; color: #1565c0;">Tu dinero llegará en <strong>15 minutos</strong></span>
        </div>
      </div>

      <!-- Action buttons -->
      <button type="button" (click)="shareTransaction()"
        style="width: 100%; padding: 14px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; margin-bottom: 12px; display: flex; align-items: center; justify-content: center; transition: all 0.2s;"
        onmouseover="this.style.background='#f0f9f5'" onmouseout="this.style.background='white'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right: 8px;">
          <path d="M4 12v4a2 2 0 002 2h8a2 2 0 002-2v-4M10 2v10M10 2l-4 4M10 2l4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        Compartir operación
      </button>

      <button type="button" (click)="finishTransaction()"
        style="width: 100%; padding: 16px; background: #1C593D; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: background 0.2s, transform 0.1s;"
        onmouseover="this.style.background='#258068'" onmouseout="this.style.background='#1C593D'">
        Finalizar
      </button>
    </div>
  </div>

  <!-- ═══ Modal de Tasas ═══ -->
  <div *ngIf="showRatesModal" class="rates-overlay"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999; padding: 16px;">
    <div class="rates-content modal-animate"
      style="background: white; border-radius: 20px; max-width: 450px; width: 100%; max-height: 90vh; overflow-y: auto; box-shadow: 0 10px 40px rgba(0,0,0,0.2);">

      <!-- Header gradient Aguacate -->
      <div style="background: linear-gradient(135deg, #1C593D, #2d8f5e); padding: 20px; border-radius: 20px 20px 0 0; display: flex; justify-content: space-between; align-items: center;">
        <h3 style="font-size: 18px; font-weight: 700; color: white; margin: 0;">Tasas de Cambio del Día</h3>
        <button type="button" (click)="closeRatesModal()"
          style="background: rgba(255,255,255,0.2); border: none; cursor: pointer; color: white; width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center;"
          onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div *ngIf="tasasCambio" style="padding: 20px;">
        <p style="text-align: center; font-size: 14px; font-weight: 600; color: #6b7280; margin: 0 0 20px;">{{ isVeUser ? 'VES → CLP' : 'CLP → VES' }}</p>

        <!-- Rango A -->
        <div style="background: #f9fafb; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; margin-bottom: 12px;">
          <div style="margin-bottom: 8px;">
            <span style="font-size: 13px; font-weight: 600; color: #6b7280;">{{ tasasCambio.rangoA.monto }}</span>
          </div>
          <div *ngIf="!isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoA.client | number:'1.4-4' }} VES
          </div>
          <div *ngIf="isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoA.client | number:'1.4-4' }} VES
          </div>
        </div>

        <!-- Rango B -->
        <div style="background: #f9fafb; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; margin-bottom: 12px;">
          <div style="margin-bottom: 8px;">
            <span style="font-size: 13px; font-weight: 600; color: #6b7280;">{{ tasasCambio.rangoB.monto }}</span>
          </div>
          <div *ngIf="!isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoB.client | number:'1.4-4' }} VES
          </div>
          <div *ngIf="isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoB.client | number:'1.4-4' }} VES
          </div>
        </div>

        <!-- Rango C -->
        <div style="background: #f9fafb; border: 2px solid #1C593D; border-radius: 12px; padding: 16px; margin-bottom: 12px;">
          <div style="margin-bottom: 8px;">
            <span style="font-size: 13px; font-weight: 600; color: #6b7280;">{{ tasasCambio.rangoC.monto }}</span>
          </div>
          <div *ngIf="!isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoC.client | number:'1.4-4' }} VES
          </div>
          <div *ngIf="isVeUser" style="font-size: 18px; font-weight: 700; color: #111827; text-align: center;">
            1 CLP = {{ tasasCambio.rangoC.client | number:'1.4-4' }} VES
          </div>
        </div>

        <p style="text-align: center; font-size: 12px; color: #9ca3af; font-style: italic; margin: 16px 0 0;">Tasas actualizadas automáticamente</p>
      </div>

      <div style="padding: 0 20px 20px;">
        <button type="button" (click)="closeRatesModal()"
          style="width: 100%; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s;"
          onmouseover="this.style.background='#16452f'" onmouseout="this.style.background='#1C593D'">
          Cerrar
        </button>
      </div>
    </div>
  </div>

</div>
